import { render, staticRenderFns } from "./VasionTreeItem.vue?vue&type=template&id=87bcc028&"
import script from "./VasionTreeItem.vue?vue&type=script&lang=js&"
export * from "./VasionTreeItem.vue?vue&type=script&lang=js&"
import style0 from "./VasionTreeItem.vue?vue&type=style&index=0&id=87bcc028&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports